<!-- 教研活动 -->
<template>
    <div class="teach-activity">
        <div class="teach-activity-top">
            <div class="title">教研活动</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teach-activity-list">
            <div class="teach-activity-item" v-for="item in activityList" :key="item.id">
                <div class="activity-number">
                    <img class="bg-img" :src="require('@/assets/images/sydataboard/bg.png')" alt="">
                    <count-up
                        class="infor-card-count user-created-count"
                        :id-name="`code_${item.name}`"
                        :end-val="item.number"
                        color="#27CDE6"
                        countSize="24px"
                        :countWeight="700"
                        :isConvert="1"
                        style="height:100%;"
                    >
                    </count-up>
                </div>
                <div class="activity-name">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
import { getTeachingResearchInfoAPI } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
  export default {
    name: 'teach-activity',
    components: {
        CountUp
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            activityList:[]
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.getTeachingResearchInfo();
            }
        }
    },
    methods: {
        /**
         * @name 跳转更多
         */
        goMore(){
            window.open(`https://jzjx.syjy.cn/research/regionside/tearesearch?token=${this.$store.getters.token}`,'_blank')
        },
        /**
         * @name 获取教研活动统计
         */
        getTeachingResearchInfo(){
            this.activityList = [];
            getTeachingResearchInfoAPI({...this.params}).then((res)=>{
                let activityList = []
                activityList.push({
                    id:'1',
                    name:"集体备课",
                    number:res.jtbkNum || 0
                })
                activityList.push({
                    id:'2',
                    name:"听评课",
                    number:res.tpkNum || 0
                })
                activityList.push({
                    id:'3',
                    name:"特色活动",
                    number:res.tshdNum || 0
                })
                this.activityList = activityList
            }).catch((err)=>{
                this.$Message.error('教研活动统计获取失败！');
            })
        }
    },
    mounted(){
        this.getTeachingResearchInfo();
    },
  }
</script>
  
<style lang="scss" scoped>
.teach-activity{
    width: 100%;
    height: 175px;
    padding: 0 15px;
    background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .teach-activity-top{
        position: relative;
        text-align: center;
        margin-bottom: 12px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teach-activity-list{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .teach-activity-item{
            display: flex;
            flex-direction: column;
            .activity-number{
                width: 80px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                // font-size: 24px;
                // font-family: DingTalk JinBuTi;
                // font-weight: 400;
                // color: #2B7FFF;
                // background:url("../../../assets/images/sydataboard/bg.png") ;
                position: relative;
                .bg-img{
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    position: absolute;
                }
                .infor-card-count{
                    display: flex;
                    align-items: center;
                }
            }
            .activity-name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #A1B6EB;
                margin-top: 15px;
            }
        }
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
</style>